import { DateTime } from 'luxon'
import { useCallback, useMemo, useState } from 'react'
import { useSharedContext } from '@leverege/ui-plugin'
import { Constants } from '../../../../util'

export default function useTrafficBarChart( opts ) {
  const { events } = opts

  const [ type, setType ] = useState( 'count' )
  const { operatingHours } = useSharedContext()

  const onSetType = useCallback( ( { data } ) => {
    setType( data )
  }, [] )

  const { data } = useMemo( () => {
    const ret = Constants.DAYS_OF_WEEK.reduce( ( prev, curr ) => {
      prev[curr] = {
        dog : 0,
        person : 0,
        dates : new Set(),
        events : {
          dog : [],
          person : [],
          total : []
        }
      }

      return prev
    }, {} )

    const start = DateTime.fromISO( events.start )
    const end = DateTime.fromMillis(
      Math.min(
        new Date( events.end ),
        DateTime.local().setZone( operatingHours.timezone, { keepLocalTime : true } )
      )
    )

    for ( let i = start; i < end; i = i.plus( { day : 1 } ) ) {
      const day = i.get( 'weekdayLong' )
      const date = i.toISODate()

      if ( ret[day] && !ret[day].dates.has( date ) ) {
        ret[day].dates.add( date )
      }
    }

    events?.items?.forEach( ( item ) => {
      const { time, data } = item
      const dateTime = DateTime.fromISO( time )
      const day = dateTime.get( 'weekdayLong' )

      if ( ret[day] ) {
        ret[day].events.total.push( item )
        if ( data.data?.changes?.person != null ) {
          ret[day].events.person.push( item )
          ret[day].person += 1
        }

        if ( data.data?.changes?.dog != null ) {
          ret[day].events.dog.push( item )
          ret[day].dog += 1
        }
      }
    } )

    const d = Object
      .entries( ret )
      .map( ( [ day, data ] ) => {

        return {
          day,
          person : data.person,
          dog : data.dog,
          dates : data.dates,
          events : data.events
        }
      } )

    return {
      data : d
    }
  }, [ events ] )
  const config = useMemo( () => {
    return {
      scale : {
        x : { type : 'band', padding : 0.3 },
        y : { type : 'linear' }
      },
      accessors : {
        person : {
          xAccessor : d => d.day,
          yAccessor : ( d ) => {
            return type === 'count' ? d.person : Math.round( d.person / d.dates.size )
          }
        },
        dog : {
          xAccessor : d => d.day,
          yAccessor : ( d ) => {
            return type === 'count' ? d.dog : Math.round( d.dog / d.dates.size )
          }
        }
      },
      tickFormat : {
        x : ( value ) => {
          return value.charAt( 0 )
        }
      }
    }
  }, [ type ] )

  return {
    config,
    data,
    type,
    onSetType
  }
}
